'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { Stack } from '@s7/layout';
import { Typography, Divider } from '@s7/ui';
import { useMediaQueryContext } from '../../Footer.context.js';
import { extractContextProps, FooterNavigationProvider } from './FooterNavigation.context.js';
import { FooterNavigationMobile } from './layouts/FooterNavigationMobile.js';
import { FooterNavigationDesktop } from './layouts/FooterNavigationDesktop.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const FooterNavigation = (props)=>{
    const { title, categories, headingProps } = props, others = _object_without_properties_loose(props, [
        "title",
        "categories",
        "headingProps"
    ]);
    const [contextValue, rest] = extractContextProps(others);
    const [isDesktop, isTablet] = useMediaQueryContext();
    const isMobile = !isDesktop && !isTablet;
    // FIXME
    return /*#__PURE__*/ jsxs(FooterNavigationProvider, {
        value: contextValue,
        children: [
            /*#__PURE__*/ jsxs(Stack, _extends({
                breakpoints: {
                    'sm1.up': {
                        spacing: 36
                    }
                },
                spacing: 20
            }, rest, {
                children: [
                    title && /*#__PURE__*/ jsx(Typography, _extends({
                        size: "md1",
                        variant: "heading"
                    }, headingProps, {
                        children: title
                    })),
                    categories && (isMobile ? /*#__PURE__*/ jsx(FooterNavigationMobile, {
                        categories: categories
                    }) : /*#__PURE__*/ jsx(FooterNavigationDesktop, {
                        categories: categories
                    }))
                ]
            })),
            !isMobile && /*#__PURE__*/ jsx(Divider, {})
        ]
    });
};

export { FooterNavigation };
//# sourceMappingURL=FooterNavigation.js.map
